import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot, useAdaptiveColorContext, useAdaptiveHeightContext } from '@nettbureau/core';
import { Icon } from '@nettbureau/icon';
import { ProgressCircle } from '@nettbureau/progress';
import { useCss } from '@nettbureau/styling';
import { Button } from './button.js';
import { useButtonGroupContext } from './button-group-context.js';

/**
 * Icon buttons are a type of button that has no label other than an icon.
 */ const IconButton = createPolymorphicComponent((props, ref)=>{
    const buttonGroupProps = useButtonGroupContext();
    const [mergedProps, mergedRef] = useSlot('IconButton', {
        ...buttonGroupProps,
        ...props
    }, ref);
    const { color = useAdaptiveColorContext() ?? 'neutral', css, disabled = false, icon, loading = false, size = useAdaptiveHeightContext() ?? 'md', variant = 'soft', ...buttonProps } = mergedProps;
    const buttonCss = useCss(({ theme })=>({
            padding: 0,
            width: `${theme.heights[size]}px`
        }));
    return /*#__PURE__*/ jsx(Button, {
        "data-icon-button": true,
        ...buttonProps,
        ref: mergedRef,
        color: color,
        css: [
            buttonCss,
            css
        ],
        disabled: disabled || loading,
        size: size,
        variant: variant,
        children: loading ? /*#__PURE__*/ jsx(ProgressCircle, {
            size: size
        }) : /*#__PURE__*/ jsx(Icon, {
            color: color,
            icon: icon
        })
    });
});

export { IconButton };
//# sourceMappingURL=icon-button.js.map
